import { createNamespacedHelpers } from 'vuex';
import apiAuth from '@/api/auth.js';
import { Token } from '@/api/token.js';
import ConciergeDefs from '@/store/concierge/concierge.d';
import ChatDefs from '@/store/chat/chat.d';
import LoadingDots from '@/components/loading_dot/LoadingDot.vue';
import Config from '@/config';

const { mapActions: mapConciergeActions } = createNamespacedHelpers(
  'Concierge'
);

const { mapActions: mapChatActions } = createNamespacedHelpers('Chat');

export default {
  name: 'AuthForm',

  data: function() {
    return {
      formData: {
        email: null,
        password: null,
        rememberMe: true,
        emailDescription: null,
        passwordDescription: null,
        formError: null
      },
      isAuthLoading: false,
      version: Config.Version
    };
  },
  components: {
    LoadingDots
  },
  methods: {
    ...mapConciergeActions({
      conciergeStore_setCurrentConcierge:
        ConciergeDefs.actions.setCurrentConcierge
    }),

    ...mapChatActions({
      chatStore_connect: ChatDefs.actions.connect,
      chatStore_leavePreviousChannels: ChatDefs.actions.leavePreviousChannels
    }),

    loginConcierge: async function() {
      this.formData.formError = null;
      this.isAuthLoading = true;
      if (!this.formData.email || !this.formData.password) {
        this.formData.formError = 'Require email and password';
        return;
      }

      try {
        let loginSession = await apiAuth.authenticateConcierge(this.formData);
        Token.setConciergeSession(loginSession);

        await this.conciergeStore_setCurrentConcierge(loginSession.conciergeId);
        await this.chatStore_connect({
          id: loginSession.conciergeId,
          token: loginSession.sbAccessToken
        });

        await this.chatStore_leavePreviousChannels();
        this.isAuthLoading = false;
        this.$router.push({ name: 'Chat' });
      } catch (error) {
        this.formData.formError = 'Invalid email, or password.';
        this.isAuthLoading = false;
      }
    }
  }
};
